export const typeOfEnquiryOptions = ['Enquiry', 'QuickEnquiry', 'LandRegistryViewer', 'All', 'FollowUp', 'Comment'];
export const transactionTypeOptions = ['Timber Purchase', 'Timber Sales', 'General', 'Send Brochure'];
export const countyDropDownOptions = [
  'Antrim',
  'Armagh',
  'Carlow',
  'Cavan',
  'Clare',
  'Cork',
  'Donegal',
  'Down',
  'Dublin',
  'Fermanagh',
  'Galway',
  'Kerry',
  'Kildare',
  'Kilkenny',
  'Laois',
  'Leitrim',
  'Limerick',
  'Londonderry',
  'Longford',
  'Louth',
  'Mayo',
  'Meath',
  'Monaghan',
  'Offaly',
  'Roscommon',
  'Sligo',
  'Tipperary',
  'Tyrone',
  'Waterford',
  'Westmeath',
  'Wexford',
  'Wicklow',
];
export const allocatedToOptions = ['Eoin', 'Cormac', 'Ken', 'Lee', 'Other'];
export const pipelineStatusOptions = [
  'Lost',
  'Made contact',
  'Interested',
  'Grower agrees WH work on their behalf',
  'Site visit arranged',
  'Site visit completed',
  'Price sent',
  'Price agreed',
  'Contract sent',
  'Contract signed',
  'Harvesting completed',
  'Timber roadside',
  'Site completed',
  'Stock Reconciled',
  'Follow up later',
];
export const enquiryRatingOptions = ['Excellent', 'Good', 'Okay', 'Poor'];
